export const navLinksdata = [
  {
    _id: 1001,
    titleKey: "home",
    link: "home",
  },
  {
    _id: 1002,
    titleKey: "services",
    link: "features",
  },
  {
    _id: 1003,
    titleKey: "projects",
    link: "projects",
  },
  {
    _id: 1004,
    titleKey: "resume",
    link: "resume",
  },
  {
    _id: 1005,
    titleKey: "testimonial",
    link: "testimonial",
  },
  {
    _id: 1006,
    titleKey: "contact",
    link: "contact",
  },
];